import OtherOffer from '../../cards/other-offer';
import OtherOfferRate from '../../cards/other-offer-rate';
import { Branch, Card } from '../../components/deck';

export default (continuation) =>
  Branch(
    {
      other: Card(
        OtherOffer,
        Branch(
          {
            otherRate: Card(OtherOfferRate)
          },
          ({ model }) => model.getIn(['loan', 'otherOffer']) && 'otherRate'
        )
      )
    },
    ({ model }) => model.getIn(['loan', 'acceptedOffer']) && 'other',
    continuation
  );



// WEBPACK FOOTER //
// ./src/decks/branches/other-offer.js